import { requestJson } from '../../../shared/api/http'
import { type MetricsResponse } from '../model/contracts'

export async function fetchMetrics(signal?: AbortSignal): Promise<MetricsResponse> {
  return requestJson<MetricsResponse>('/api/v1/metrics', {
    method: 'GET',
    signal,
  })
}
